<div class="content-wrapper reports-container">
  <!-- Content Header (Page header) -->
  <div
    class="col-md-12 layout-spacing widget quick-category"
    style="margin-top: 30px"
  >
    <a class="widget quick-category">
      <div class="quick-category-head">
        <h5 class="card-title">{{ 'record.filter.title' | translate }}</h5>
        <div class="ml-auto">
          <button
            *ngIf="!areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.contract' | translate }}</span>
            <i class="las la-arrow-up"></i>
          </button>
          <button
            *ngIf="areFiltersCollapsed"
            class="btn quick-comparison qcompare-success"
            (click)="areFiltersCollapsed = !areFiltersCollapsed"
          >
            <span>{{ 'record.filter.advancedSearch' | translate }}</span>
            <i class="las la-arrow-down"></i>
          </button>
        </div>
      </div>
      <div class="quick-category-content">
        <div class="row">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.startDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="minDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [maxDate]="maxDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.endDate' | translate }}
              </h6>
              <div>
                <input
                  bsDatepicker
                  [(ngModel)]="maxDate"
                  readonly
                  class="form-control flatpickr flatpickr-input active"
                  type="text"
                  placeholder="{{ 'record.filter.selectDate' | translate }}"
                  [bsConfig]="{
                    isAnimated: true,
                    containerClass: 'theme-dark-blue',
                    dateInputFormat: 'DD-MM-YYYY'
                  }"
                  [minDate]="minDate"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title mb-2">
                {{ 'record.filter.minOccurrences' | translate }}
                <span class="occ-badge" [class.occ-badge--active]="minOccurrences > 0">
                  {{ minOccurrences > 0 ? '≥ ' + minOccurrences : ('record.filter.all' | translate) }}
                </span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13" height="13"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="lucide lucide-info occ-info-icon"
                  container="body"
                  placement="top"
                  animation="true"
                  [openDelay]="200"
                  [closeDelay]="150"
                  ngbTooltip="{{ 'record.filter.minOccurrencesTooltip' | translate }}"
                >
                  <circle cx="12" cy="12" r="10" />
                  <path d="M12 16v-4" />
                  <path d="M12 8h.01" />
                </svg>
              </h6>
              <input
                type="range"
                class="occ-range"
                min="0"
                max="100"
                step="1"
                [(ngModel)]="minOccurrences"
                [style.--fill]="minOccurrences + '%'"
              />
              <div class="occ-ticks-labels">
                <span>0</span><span>50</span><span>100</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row" [ngbCollapse]="areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">Email</h6>
              <div>
                <input
                  [(ngModel)]="user"
                  class="form-control"
                  placeholder="Email"
                  type="text"
                  id="example-text-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">Nombre</h6>
              <div>
                <input
                  [(ngModel)]="name"
                  class="form-control"
                  placeholder="Nombre"
                  type="text"
                  id="example-name-input"
                />
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.table.type' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="actions"
                [closeOnSelect]="false"
                [(ngModel)]="selectedActions"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.department' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                (scrollToEnd)="cargarMasOpciones()"
                [items]="departments"
                [closeOnSelect]="false"
                [(ngModel)]="selectedDeptos"
                multiple="true"
              ></ng-select>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.policy' | translate }}
              </h6>
              <ng-select
                class="selectpicker"
                [items]="priorities"
                [closeOnSelect]="false"
                [(ngModel)]="selectedPriorities"
                multiple="true"
                bindLabel="displayName"
                bindValue="guid"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!areFiltersCollapsed">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.externalDelivery' | translate }}
              </h6>
              <div class="checkbox-wrapper-13 ml-3">
                <input
                  id="c1-13"
                  type="checkbox"
                  [(ngModel)]="trueExternalDelivery"
                />
                <label for="c1-13">{{
                  'utilities.filters.yes' | translate
                }}</label>

                <input
                  id="c1-14"
                  class="ml-3"
                  type="checkbox"
                  [(ngModel)]="falseExternalDelivery"
                />
                <label for="c1-14">{{
                  'utilities.filters.no' | translate
                }}</label>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">
                {{ 'record.filter.informationLeakEvents' | translate }}
              </h6>
              <div class="checkbox-wrapper-13 ml-3">
                <input id="c1-13" type="checkbox" [(ngModel)]="trueInfoLeak" />
                <label for="c1-13">{{
                  'utilities.filters.yes' | translate
                }}</label>

                <input
                  id="c1-14"
                  class="ml-3"
                  type="checkbox"
                  [(ngModel)]="falseInfoLeak"
                />
                <label for="c1-14">{{
                  'utilities.filters.no' | translate
                }}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row" *ngIf="!areFiltersCollapsed && trueExternalDelivery && !falseExternalDelivery">
          <div class="col-md-3">
            <div class="form-group column">
              <h6 class="card-title">Dominios excluidos</h6>
              <ng-select
                class="selectpicker"
                [(ngModel)]="excludedDomains"
                [addTag]="validateAndAddDomain"
                addTagText="Agregar dominio"
                multiple="true"
                placeholder="ej: dominio.com"
              ></ng-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="btn-filtros">
              <button
                style="padding: 5px 30px; width: 110px"
                type="button"
                class="btn btn-primary"
                [disabled]="isLoading"
                (click)="setFilters()"
              >
                {{ 'record.filter.filter' | translate }}
              </button>
              <button
                style="padding: 5px 0px; width: 110px"
                type="button"
                class="btn btn-outline-primary"
                [disabled]="isLoading"
                (click)="cleanFilters()"
              >
                {{ 'record.filter.cleanFilters' | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </a>

    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <div class="btn-informes">
          <button
            style="
              padding: 5px 25px;
              width: 165px;
              height: 35px;
              display: flex;
              justify-content: center;
              align-items: center;
              gap: 6px;
            "
            id="btnGroupVerticalDropdown"
            type="button"
            class="btn btn-primary dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            [disabled]="isLoading"
          >
            <i class="icon download-button" style="height: 17px"></i>
            {{ 'record.download.download' | translate }}
            <i class="las la-angle-down"></i>
          </button>
          <div class="dropdown-menu" aria-labelledby="btnGroupVerticalDropdown">
            <button class="dropdown-item" (click)="generateGeneralIrmReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.overviewReport' | translate }}
            </button>
            <button class="dropdown-item" (click)="generateEvoDlpReport()">
              <i class="icon download-type"></i>
              {{ 'record.download.evolutionaryReport' | translate }}
            </button>
          </div>
        </div>
        <button
          *ngIf="isAiButtonVisible"
          style="padding: 5px 18px; height: 35px; display: flex; justify-content: center; align-items: center; gap: 6px; margin-left: 24px; margin-right: 16px; background: linear-gradient(135deg, #1a2a6c, #2d4a9e); color: white; border: none;"
          type="button"
          class="btn"
          [disabled]="isLoading"
          (click)="openAiAnalysis()"
        >
          <span style="position:relative; display:inline-flex; align-items:center;">
            <i class="las la-robot" style="font-size: 18px;"></i>
            <i class="las la-lock" style="position:absolute; font-size:11px; bottom:-2px; right:-5px; color:#ffd700;"></i>
          </span>
          {{ 'ai.button' | translate }}
          <span style="background:#ffd700; color:#1a2a6c; font-size:9px; font-weight:800; padding:1px 5px; border-radius:3px; margin-left:2px; letter-spacing:0.5px;">PRO</span>
        </button>
        <div class="d-flex align-items-center gap-1">
          <ng-container *ngIf="!isCountLoading">
            {{ 'record.recordsCount' | translate : { count: reports?.length || '0', total: collectionSize } }}
          </ng-container>
          <ng-container *ngIf="isCountLoading">
            {{ 'record.recordsCountLoading' | translate : { count: reports?.length || '0' } }}
            <span class="spinner-border spinner-border-sm text-secondary" style="width:0.75rem;height:0.75rem;margin-left:4px" role="status" aria-hidden="true"></span>
          </ng-container>
        </div>
      </div>
    </div>

    <div>
      <table class="table table-striped">
        <thead>
          <tr>
            <th scope="col" sortable="date" (sort)="onSort($event)">
              {{ 'record.table.date' | translate }}
            </th>
            <th scope="col" sortable="title" (sort)="onSort($event)">
              {{ 'record.table.affair' | translate }}
            </th>
            <th scope="col" sortable="filepath" (sort)="onSort($event)">
              {{ 'record.table.file' | translate }}
            </th>
            <th scope="col" sortable="actor" (sort)="onSort($event)">
              {{ 'record.table.user' | translate }}
            </th>
            <th scope="col" sortable="area" (sort)="onSort($event)">
              {{ 'record.table.department' | translate }}
            </th>
            <th scope="col" sortable="policiid" (sort)="onSort($event)">
              {{ 'record.table.policy' | translate }}
            </th>
            <th
              scope="col"
              style="width: 12%"
              sortable="totalCount"
              (sort)="onSort($event)"
            >
              {{ 'record.table.ocurrences' | translate }}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="lucide lucide-info-icon lucide-info"
                data-toggle="tooltip"
                placement="top"
                animation="true"
                container="body"
                [openDelay]="300"
                [closeDelay]="300"
                ngbTooltip="{{ 'record.table.infoOcurrences' | translate }}"
              >
                <circle cx="12" cy="12" r="10" />
                <path d="M12 16v-4" />
                <path d="M12 8h.01" />
              </svg>
            </th>
            <th scope="col" style="width: 12%">
              {{ 'record.table.sensitiveData' | translate }}
            </th>
          </tr>
        </thead>
        <tbody *ngIf="isLoading">
          <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]">
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
            <td><div class="skeleton skeleton-row"></div></td>
          </tr>
        </tbody>
        <tbody *ngIf="!isLoading">
          <tr
            style="height: 50px; overflow: scroll"
            *ngFor="let report of reports"
          >
            <td>
              {{ report.date | tableDate : 'date' }} <br />
              {{ report.date | tableDate : 'time' }}
            </td>
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              ngbTooltip="{{ report.title }}"
            >
              {{ (report.title | cutString) || '' }}
            </td>
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              ngbTooltip="{{ report.attachmentsNames }}"
            >
              {{ report.attachmentsNames | cutString }}
            </td>
            <td>{{ report.actor }}</td>
            <td>{{ report.area }}</td>
            <td
              data-toggle="tooltip"
              placement="top"
              animation="true"
              container="body"
              [openDelay]="300"
              [closeDelay]="300"
              ngbTooltip="{{ report.dlpCompliancePolicy }}"
            >
              {{ report.dlpCompliancePolicy | cutString }}
            </td>
            <td>{{ report.totalCount }}</td>
            <td>
              <span
                style="color: #4456b9; cursor: pointer"
                (click)="seeSensitiveData(report.sensitiveInformationTypes)"
              >
                {{ 'record.table.seeSensitiveData' | translate }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div
      *ngIf="reports?.length <= 0 && !isLoading"
      class="d-flex justify-content-center"
    >
      <span>{{ 'noDataAvailable' | translate }}</span>
    </div>
  </div>

  <div
    class="d-flex justify-content-center p-2 paginator-container"
    *ngIf="reports?.length > 0"
  >
    <div class="items-per-page-container">
      <label for="pageSizeSelect" class="mr-2 mb-0">{{
        'record.filter.itemsPerPage' | translate
      }}</label>
      <select
        id="pageSizeSelect"
        class="form-control"
        style="width: auto; display: inline-block"
        [(ngModel)]="pageSize"
        (change)="refreshReports()"
      >
        <option [ngValue]="10">10</option>
        <option [ngValue]="20">20</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <ngb-pagination
      [collectionSize]="collectionSize"
      [(page)]="page"
      [pageSize]="pageSize"
      [rotate]="true"
      [maxSize]="5"
      [ellipses]="false"
      [boundaryLinks]="true"
      (pageChange)="refreshReports()"
    >
    </ngb-pagination>
  </div>
</div>
